import React, {Component} from 'react';
import './tabbedNav.css';

class NavLink extends Component {
  handleClick = () => {
    this.props.onClick(this.props.index);
  }

  render() {
    const buttonStyles = {
      border: "none",
      margin: 0,
      padding: 0,
      width: "auto",
      overflow: "visible",
      background: "transparent",
      font: "inherit",
      lineHeight: "normal",
    }

    return (
      <button onClick={this.handleClick} style={{cursor:"pointer", ...buttonStyles}}>
        {this.props.children}
      </button>
    );
  }
}

class TabbedNav extends Component {
  render() {
    const {activeTab, onTabChange, data} = this.props;
    return (
      <nav className="tabbedNav" style={{borderBottom: "2px solid #508FCA"}}>
        <ul style={{margin:0,padding:0}}>
          {data.map((item, i) =>
            <li key={i} className={`tabbedNavItem ${activeTab === item.id && 'selected'}`} style={{
              listStyle: "none",
              display: "inline-block",
              margin:"0 32px 10px 0",
              fontSize: "24px",
            }}>
              <NavLink index={item.id} onClick={onTabChange}>{item.attributes.label}</NavLink>
            </li>
            )}
        </ul>
      </nav>
    );
  }
}

export default TabbedNav;
